import React from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import TranslateIgnoreText from '@this/components/shared/text/translate_ignore_text';
import type TravelerInformation from '@this/src/domain/traveler_information';
import type OrderItem from '@this/src/domain/order_item2';
import type NonOrderItem from '@this/src/domain/non_order_item2';
import { createAITTheme } from '@this/shared/ui/theme';

const utils = require('@this/src/utils');

interface Props {
  item: OrderItem | NonOrderItem;
  traveler: TravelerInformation;
  price: number;
  itemName: string;
  index: number;
}

const ContentInfo: React.FC<Props> = ({ item, traveler, price, itemName, index }) => {
  const theme = createAITTheme();
  const tableCellStyle = {
    border: `1px solid ${theme.tokens.colors.border.divider}`,
    padding: '10px 16px'
  };

  const tableCellRightStyle = {
    ...tableCellStyle,
    textAlign: 'right' as const
  };

  const elementHeaderStyle = {
    fontWeight: 'bold' as const
  };

  return (
    <TableRow key={index}>
      <TableCell key={`itemName-${index}`} style={tableCellStyle}>
        {itemName}
      </TableCell>
      <TableCell key={`summary-${index}`} style={tableCellStyle}>
        {item.elements.map((el, elIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`element-${elIndex}`}>
            {el.name && <div style={elementHeaderStyle}>{el.name}</div>}
            <TranslateIgnoreText text={el.summary} />
          </React.Fragment>
        ))}
      </TableCell>
      <TableCell key={`title-${index}`} style={tableCellStyle}>
        {item.elements.map((el, elIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`title-${elIndex}`}>{el.title}</React.Fragment>
        ))}
      </TableCell>
      <TableCell key={`traveler-${index}`} style={tableCellStyle}>
        {traveler.name}
      </TableCell>
      <TableCell key={`price-${index}`} style={tableCellRightStyle}>
        <span data-wovn-ignore>{utils.digits(price)}</span>
        <span>円</span>
      </TableCell>
    </TableRow>
  );
};

export default ContentInfo;
